
import Vue from "vue";
export default Vue.extend({
  props:['input' , 'initial'],
  methods:{
    change(val:any){
      this.input.val = val

      // if (this.type == 'number') {
      //   val = parseInt(val)
      // }
      if(this.input.isNumber) {
        val = parseFloat(val)
      }
      this.$emit('input'  ,val)
    }
  }
});
